import Model from '@/models/Model.js';

export default class CourseSettingsTemplate extends Model {
    static entity = 'course_settings_templates';

    static fields() {
        return {
            id: this.attr(null),
            attendance_scenario_id: this.attr(null),
            enrollment_capacity: this.attr(null),
            course_key_enabled: this.boolean(false),
            has_flexible_attendance: this.boolean(false),
            expected_scheduled_time: this.attr(null),
            show_student_enrollments: this.boolean(true),
            permit_extra_credit_overflow: this.boolean(false),
            is_pass_or_fail: this.boolean(true),

            ...super.fields(),

            course_template: this.hasOne('course_templates', 'course_settings_template_id'),
            attendance_scenario: this.belongsTo('attendance_scenarios', 'attendance_scenario_id'),
        };
    }
}
